module.exports = __webpack_public_path__ + "img/D&D-Elemente_Welle_Kapitel4.e77776a1.svg";